<template>
  <router-link class="cta-pill" :to="destination">Get Full Access</router-link>
</template>

<script setup>
import {computed} from "vue";
import {useRoute} from "vue-router";
import useUserSafe from "@/composables/useUserSafe";

const route = useRoute();
const {isSignedIn} = useUserSafe();

const destination = computed(() => {
  if (isSignedIn.value) return {name: "Videos_Unlock"};
  return {path: route.path, hash: "#sign-in"};
});
</script>

<style src="./pill.css"></style>
